import { render } from "./dragdrop.vue?vue&type=template&id=c8bbf624"
import script from "./dragdrop.vue?vue&type=script&lang=js"
export * from "./dragdrop.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__